// extracted by mini-css-extract-plugin
export default {"main":"hca-z"};